/**
 * Product Recommendations AJAX Loader
 * Handles dynamic loading of Shopify product recommendations
 */

(function() {
  'use strict';

  const SELECTORS = {
    container: '.t4s-product-extra[data-baseurl]',
    loader: '.t4s-loading--bg'
  };

  /**
   * Fetch and inject product recommendations
   */
  function loadRecommendations(container) {
    const baseUrl = container.getAttribute('data-baseurl');
    const productId = container.getAttribute('data-id');
    const limit = container.getAttribute('data-limit') || 8;
    const sectionId = container.getAttribute('data-sid');
    
    if (!baseUrl || !productId) {
      console.warn('Product recommendations: Missing required data attributes');
      return;
    }

    // Build the URL for recommendations
    const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`;
    
    console.log('Loading recommendations from:', url);

    // Fetch recommendations
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then(html => {
        if (!html || html.trim() === '') {
          console.warn('Product recommendations: Empty response');
          container.style.display = 'none';
          return;
        }

        console.log('Recommendations HTML received, length:', html.length);

        // Create a temporary container to parse the HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // Try to find the section first
        const sectionInner = tempDiv.querySelector('.t4s-section-inner');
        
        if (sectionInner) {
          console.log('Found section-inner with products');
          
          // Force visibility on all elements
          sectionInner.style.opacity = '1';
          sectionInner.style.visibility = 'visible';
          sectionInner.style.display = 'block';
          
          // Remove any hiding attributes
          sectionInner.removeAttribute('hidden');
          sectionInner.removeAttribute('hdt-reveal');
          
          // Force visibility on all product elements
          const products = sectionInner.querySelectorAll('.t4s-product, .t4s-pr-grid, .t4s-product-wrapper, [timeline]');
          products.forEach(el => {
            el.style.opacity = '1';
            el.style.visibility = 'visible';
            el.removeAttribute('hdt-reveal');
            el.removeAttribute('timeline');
          });
          
          // Replace container with the FULL section content (WITH heading)
          const parent = container.parentNode;
          parent.replaceChild(sectionInner, container);
          
          console.log('Products loaded and forced visible');
          
          // Trigger custom event
          const event = new CustomEvent('product-recommendations:loaded', {
            detail: { container: sectionInner, productId }
          });
          document.dispatchEvent(event);

          // Initialize Flickity sliders
          if (window.jQuery_T4NT && typeof window.jQuery_T4NT.fn.flickityt4s === 'function') {
            setTimeout(() => {
              window.jQuery_T4NT(sectionInner).find('.flickityt4s-later').each(function() {
                console.log('Initializing Flickity slider');
                window.jQuery_T4NT(this).flickityt4s();
              });
            }, 100);
          }
        } else {
          console.warn('Product recommendations: No section found in response');
          container.style.display = 'none';
        }
      })
      .catch(error => {
        console.error('Product recommendations loading error:', error);
        container.style.display = 'none';
      });
  }

  /**
   * Initialize all recommendation containers on the page
   */
  function init() {
    const containers = document.querySelectorAll(SELECTORS.container);
    
    if (containers.length === 0) {
      return;
    }

    containers.forEach(container => {
      // Only load if not already loaded
      if (!container.hasAttribute('data-recommendations-loaded')) {
        container.setAttribute('data-recommendations-loaded', 'true');
        loadRecommendations(container);
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on dynamic content changes (e.g., quick view, AJAX)
  document.addEventListener('shopify:section:load', init);
  
  // Expose init function for manual triggering if needed
  window.T4SProductRecommendations = {
    init: init,
    load: loadRecommendations
  };
})();
